angular.module('impactx.address').controller('AddressListController', [
    'selectedListItems',
    AddressListCtrl
]);

function AddressListCtrl(selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditCompanyAddress'
        },
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/address/templates/addresslist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/address/list',
        ctrl: this,
        id: "addresslist",
        mainAction: {id: "new", link: "#/addressdetail/0", icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "addressdetail/" + selectedListItems.getFirstSelectedId();
    }
}